import { Flex, Text } from '@chakra-ui/core';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { useReviews } from '../../api/requests';
import BarkIcon from '../../assets/bark-mini.svg';
import GoogleIcon from '../../assets/google-mini.svg';
import TrustPilotIcon from '../../assets/trustpilot-mini.svg';
import YelpIcon from '../../assets/yelp.svg';

const SOURCE_ICONS = {
    google: GoogleIcon,
    yelp: YelpIcon,
    trustpilot: TrustPilotIcon,
    bark: BarkIcon,
}

function Reviews() {
  const { data } = useReviews();

  if(!data || !data?.length) return null;

  return (
    <section className="how_it_works container">
      <h2 className="headline-2 w-100 center">
        Here's what people say about us
      </h2>
      <ResponsiveMasonry
        columnsCountBreakPoints={{
          500: 1,
          768: 2,
          1200: 3,
        }}
        style={{ marginTop: 72 }}
      >
        <Masonry gutter='2rem'>
          {data?.map((review, index) => (
            <Flex
              direction="column"
              className="masonry__item"
              key={index}
              h="100%"
              style={{ gap: 16 }}
              textAlign={"left"}
              border="1px solid #eaeaea"
              borderRadius={15}
              padding="2rem"
            >
              <Flex alignItems="center" justifyContent="space-between">
                <Flex alignItems="center" style={{ gap: 16 }}>
                  <img src={review.avatar.url} alt="avatar" />
                  <Text fontWeight="semibold">{review.username}</Text>
                </Flex>
                <img src={SOURCE_ICONS[review.source]} alt={review.source} />
              </Flex>
              <ReactMarkdown>{review.review.markdown}</ReactMarkdown>
            </Flex>
          ))}
        </Masonry>
      </ResponsiveMasonry> 
    </section>
  );
}

export default Reviews;
